import type { GetOrganisationsBoardsQueueRequestType } from '../../api';
import { convertQueueToWorkflow } from '../helpers';
import { useGetOrganisationsBoardsQueue } from './use-get-organisations-boards-queue';

/**
 * Custom hook to get the organization board workflow by combining queue and group data.
 * Fetch organization board queue and its associated groups,
 * then converts the queue data into a workflow format.
 *
 */
export const useGetOrganisationBoardWorkflow = (
  params: Partial<GetOrganisationsBoardsQueueRequestType>,
) => {
  const queueQuery = useGetOrganisationsBoardsQueue(params);

  const data =
    queueQuery.data?.data &&
    convertQueueToWorkflow(queueQuery.data.data, queueQuery.data.data.groups);

  return {
    ...queueQuery,
    data,
  };
};
